import { TFunction } from "i18next";
import React from "react";
import { toast } from "react-toastify";

import Button from "components/button/Button";
import { CustomToastCloseButton } from "components/icons/CustomToastCloseButton";
import { SuccessIcon } from "components/icons/SuccessIcon";
import { ToastInfoIcon } from "components/icons/ToastInfoIcon";
import componentLayoutStyles from "components/layout/layout.scss";
import MenuItemButton from "components/menu-item-button/MenuItemButton";
import layoutStyles from "styles/layout.scss";

export const copyToClipboard = (
    shaKey: string | undefined,
    iconColor: string,
    backgroundColor: string,
    t: TFunction
): void => {
    if (!shaKey) {
        return;
    }
    navigator.clipboard.writeText(shaKey).then(() =>
        toast(
            <SuccessIcon
                successClass={componentLayoutStyles.customToastSuccessIcon}
                color={backgroundColor}
                text={t("Support.supportAndHelp.softwarePackages.SHA256Copied")}
            />,
            {
                closeButton: (closeToastProps) => (
                    <CustomToastCloseButton closeToast={{ ...closeToastProps }} color={iconColor} />
                ),
                className: componentLayoutStyles.customToastSuccessMessage,
                autoClose: 2000,
            }
        )
    );
};

export const showShaChecksumToast = (
    shaValue: string,
    productName: string,
    backgroundColor: string,
    t: TFunction,
    crossIconColor: string,
    successCheckmarkColor: string,
    onClick?: () => void
): void => {
    toast(
        <div className={layoutStyles.toastWithDescriptionContainer}>
            <div>
                <ToastInfoIcon linkClass={layoutStyles.customToastLink} color={backgroundColor} onClick={() => {}} />
            </div>
            <div className={layoutStyles.toastWithDescriptionContent}>
                <div className={layoutStyles.toastWithDescriptionHeader}>
                    {t("Support.supportAndHelp.softwarePackages.verifySHA256", {
                        product_name: productName,
                    })}
                </div>
                <>
                    {shaValue}
                    <Button
                        onClick={() => {
                            copyToClipboard(shaValue, crossIconColor, successCheckmarkColor, t);
                        }}
                        variant={"TERTIARY"}
                    >
                        {t("Common.copyToClipboard")}
                    </Button>
                </>
            </div>
        </div>,
        {
            autoClose: false,
            draggable: false,
            closeOnClick: false,
            closeButton: (closeToastProps) => (
                <div>
                    <CustomToastCloseButton closeToast={{ ...closeToastProps }} color={crossIconColor} />
                </div>
            ),
            bodyClassName: layoutStyles.toastWithDescriptionContent,
            className: layoutStyles.toastWithDescription,
        }
    );
    if (onClick) {
        onClick();
    }
};

export const createShaChecksumMenuItem = (
    shaValue: string,
    productName: string,
    itemTitle: string,
    index: number | string,
    t: TFunction,
    crossIconColor: string,
    successCheckmarkColor: string
): JSX.Element => {
    return (
        <MenuItemButton
            key={index}
            onClick={() => {
                showShaChecksumToast(shaValue, productName, itemTitle, t, crossIconColor, successCheckmarkColor);
            }}
        >
            {itemTitle}
        </MenuItemButton>
    );
};
